// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".CurrencyEntityConfig__container___l34-G{width:70%;margin:0 auto;margin-bottom:60px}.CurrencyEntityConfig__title___22Y3r{font-size:20px;font-weight:600;margin:6px 0px}.CurrencyEntityConfig__subtitle___308ZH{font-size:18px;font-weight:400}.CurrencyEntityConfig__group___2cNh8{padding:10px 0px}.CurrencyEntityConfig__head___2F5wX{font-size:16px;border-bottom:1px solid #e9e9e9;font-weight:500;margin-bottom:10px}.CurrencyEntityConfig__row___m56Ch{display:flex;margin:8px 0}.CurrencyEntityConfig__key___21_is{flex:1}.CurrencyEntityConfig__value___16pw2{flex:1}\n", ""]);
// Exports
exports.locals = {
	"container": "CurrencyEntityConfig__container___l34-G",
	"title": "CurrencyEntityConfig__title___22Y3r",
	"subtitle": "CurrencyEntityConfig__subtitle___308ZH",
	"group": "CurrencyEntityConfig__group___2cNh8",
	"head": "CurrencyEntityConfig__head___2F5wX",
	"row": "CurrencyEntityConfig__row___m56Ch",
	"key": "CurrencyEntityConfig__key___21_is",
	"value": "CurrencyEntityConfig__value___16pw2"
};
module.exports = exports;
